"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recipeLinkSearchQuery = exports.menuPlannerRecipeSearchQuery = void 0;
const client_1 = require("@apollo/client");
const menuPlannerRecipe_1 = require("../../menuPlanner/fragments/menuPlannerRecipe");
const recipeName_1 = require("../fragments/recipeName");
exports.menuPlannerRecipeSearchQuery = client_1.gql `
  query MenuPlannerRecipeSearch(
    $searchQuery: String!
    $offset: Int!
    $recipesNotInCookbooks: Boolean
  ) {
    recipeSearch(
      searchQuery: $searchQuery
      offset: $offset
      recipesNotInCookbooks: $recipesNotInCookbooks
    ) @connection(key: "recipeSearch", filter: ["searchQuery"]) {
      __typename
      hasMoreRecipes
      recipes {
        ...MenuPlannerRecipe
      }
    }
  }
  ${menuPlannerRecipe_1.menuPlannerRecipeFragment}
`;
exports.recipeLinkSearchQuery = client_1.gql `
  query RecipeLinkSearch(
    $searchQuery: String!
    $offset: Int!
    $recipesNotInCookbooks: Boolean
  ) {
    recipeSearch(
      searchQuery: $searchQuery
      offset: $offset
      recipesNotInCookbooks: $recipesNotInCookbooks
    ) @connection(key: "recipeSearch", filter: ["searchQuery"]) {
      __typename
      hasMoreRecipes
      recipes {
        ...recipeName
      }
    }
  }
  ${recipeName_1.recipeNameFragment}
`;
//# sourceMappingURL=recipeSearch.js.map